import Swal from "sweetalert2";
import { append_active_organization_id } from "@/utils/organization_profile";

function show_delete_success() {
    Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Service has been deleted.",
        timer: 1200,
        showConfirmButton: false,
        position: "bottom-end",
        toast: true,
    });
}

function show_delete_error(message) {
    Swal.fire({
        icon: "error",
        title: "Error",
        text: message || "Failed to delete service",
        position: "bottom-end",
        toast: true,
        showConfirmButton: false,
        timer: 2500,
    });
}

function remove_deleted_service(context, deleted_product) {
    context.sync_catalogue_items(
        context.profile_products.filter((item) => Number(item.id) !== Number(deleted_product.id))
    );
}

export const services_delete_methods = {
    delete_product(product) {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the service!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) this.confirm_delete_product(product);
        });
    },
    confirm_delete_product(product) {
        this.is_deleting = true;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_product/`,
            method: "POST",
            headers: {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json"
            },
            data: JSON.stringify(append_active_organization_id({
                product_id: product.id,
                base_profile_id: this.base_profile_id
            })),
            success: (response) => this.handle_delete_product_response(response),
            error: (xhr) => {
                show_delete_error(xhr.responseText);
            },
            complete: () => {
                this.is_deleting = false;
            }
        });
    },
    handle_delete_product_response(response) {
        if (response.status !== "success") {
            show_delete_error(response.message);
            return;
        }
        remove_deleted_service(this, response.data);
        $("#manageProductModal").modal("hide");
        show_delete_success();
    },
};
